import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function MyTeamHeader({ value , setValue }) {
  // const [valueData, setValue] = React.useState(value);

  return (
    <>
      <Paper elevation={0}>
        <BottomNavigation
          sx={{
            overflow: "auto",
          }}
          className=" flex-wrap justify-content-start "
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction
            sx={{
              flex: "0 0 auto",
              padding: "0px",
              height:'0px !important',
              color: "#333333",
              fontSize: "14px !important",
              backgroundColor:'#f3f3f3',
              padding:'18px 30px !important',
              borderRadius:'40px',
              "& .MuiBottomNavigationAction-label": {
                whiteSpace: "nowrap !important",
                fontWeight: "500",
                fontSize: "14px !important",
              },
              ".Mui-selected&": {
                color: "#fff",
                fontSize: "14px !important",
                backgroundColor:'rgba(191, 29, 45, 0.8)',
                padding:'18px 30px !important',
                borderRadius:'40px'
              },
            }}
            label="My Team"
            component={Link}
            to={"/firehouse/my-team"}
            className={"p-0 "}
          />
          <BottomNavigationAction
            sx={{
              flex: "0 0 auto",
              padding: "0px",
              height:'0px !important',
              color: "#333333",
              fontSize: "14px !important",
              backgroundColor:'#f3f3f3',
              padding:'18px 30px !important',
              borderRadius:'40px',
              "& .MuiBottomNavigationAction-label": {
                whiteSpace: "nowrap !important",
                fontWeight: "500",
                fontSize: "14px !important",
              },
              ".Mui-selected&": {
                color: "#fff",
                fontSize: "14px !important",
                backgroundColor:'rgba(191, 29, 45, 0.8)',
                padding:'18px 30px !important',
                borderRadius:'40px'
              },
            }}
            label="My Team Today"
            component={Link}
            to={"/firehouse/my-team-today"}
            className={"mx-2 p-0 "}
          />
        </BottomNavigation>
      </Paper>
    </>
  );
}
